import GameBoard from './game-board';

export default GameBoard;
